import React from 'react';

import { connect } from 'react-redux';

import { BuildStatusProvider } from 'src/components/build-status-card/services/build-status-service/build-status-service';
import { Repository } from 'src/components/types';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';
import urls from 'src/urls/source';

const mapStateToProps = (state: BucketState) => ({
  hash: state.repository.source.section.hash,
  repository: getCurrentRepository(state),
});

type BuildStatusProps = {
  hash: string;
  repository: Repository | null | undefined;
};

const ConnectedBuildStatusProvider: React.FC<BuildStatusProps> = ({
  hash,
  repository,
  children,
}) => {
  let buildStatusURL;
  let repositoryMetadataURL;
  let repositoryFullSlug;
  if (repository && hash) {
    repositoryFullSlug = repository.full_name;
    buildStatusURL = urls.api.v20.buildStatuses(repositoryFullSlug, hash);
    repositoryMetadataURL = urls.api.internal.repositoryMetadataURL(
      repository.full_name
    );
  }

  return (
    <BuildStatusProvider
      repositoryFullSlug={repositoryFullSlug}
      buildStatusURL={buildStatusURL}
      repositoryMetadataURL={repositoryMetadataURL}
    >
      {children}
    </BuildStatusProvider>
  );
};

export default connect(mapStateToProps)(ConnectedBuildStatusProvider);
